import { render } from "./ApplicationDetail.vue?vue&type=template&id=6be57c62&scoped=true&ts=true"
import script from "./ApplicationDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationDetail.vue?vue&type=style&index=0&id=6be57c62&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be57c62"],['__file',"src/views/applications/ApplicationDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6be57c62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6be57c62', __exports__)) {
    console.log('reload')
    api.reload('6be57c62', __exports__)
  }
  
  module.hot.accept("./ApplicationDetail.vue?vue&type=template&id=6be57c62&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6be57c62', render)
  })

}


export default __exports__